import {
  format,
  isToday,
  isYesterday,
  isTomorrow,
  isAfter,
  startOfDay,
} from "date-fns";

export const formatMeetingDate = (date: Date) => {
  const dateChecks = new Map<() => boolean, string>([
    [() => isToday(date), "Today"],
    [() => isYesterday(date), "Yesterday"],
    [() => isTomorrow(date), "Tomorrow"],
  ]);

  for (const [checkFn, result] of dateChecks) {
    if (checkFn()) {
      return result;
    }
  }

  return format(date, "EEE, dd MMMM yyyy");
};

export const isOverdue = (date: Date): boolean => {
  const today = startOfDay(new Date());
  const taskDate = startOfDay(date);
  return isAfter(today, taskDate);
};

/**
 * Creates a linked entity object from the provided data
 */
export const createLinkedEntity = (
  name: string,
  systemUId: string,
  displayName: string,
  id: string | number,
  type: string
) => {
  return {
    name,
    systemUId,
    displayName,
    metaData: {
      id,
      type: type?.toLowerCase() || "",
    },
  };
};
